import React from 'react';
import './PostSkeleton.css';

const PostSkeleton = ({ isDarkMode }) => {
  return (
    <div className={`post-skeleton ${isDarkMode ? 'dark' : 'light'}`}>
      {/* Header skeleton */}
      <div className="skeleton-header">
        <div className="skeleton-avatar"></div>
        <div className="skeleton-header-content">
          <div className="skeleton-name"></div>
        </div>
      </div>
      
      {/* Content skeleton */}
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-text-line"></div>
        <div className="skeleton-text-line short"></div>
      </div>
      
      {/* Media skeleton */}
      <div className="skeleton-media"></div>
      
      {/* Actions skeleton */}
      <div className="skeleton-actions">
        <div className="skeleton-action-button"></div>
        <div className="skeleton-action-button"></div>
      </div>
    </div>
  );
};

export default PostSkeleton;
